<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "MeterImageMarker",
  data(){
    return{

    }
  },
  mounted() {
    // this.onImageLoad()
  },
  methods:{

  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_note/components/MeterImageMarker.vue